import { Component } from '@angular/core';
import { DialogOptionsService } from 'src/app/shared/services/dialog-options.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'mf-cda-main-back-redirection-dialog',
  templateUrl: './back-redirection-dialog.component.html',
  styleUrls: ['./back-redirection-dialog.component.scss']
})
export class BackRedirectionDialogComponent {
  assetsUrl = environment.assetsUrl;
  constructor(private dialogOptionsService: DialogOptionsService) {}

  redirect(redirect: boolean) {
    this.dialogOptionsService.closeDialog(redirect);
  }
}
